import * as React from "react"
import { DecoratorBlockNode } from "@lexical/react/LexicalDecoratorBlockNode"
import FigmaComponent from "./FigmaComponent"

export class FigmaNode extends DecoratorBlockNode {
  __id
  __url

  static getType() {
    return "figma"
  }

  static clone(node) {
    return new FigmaNode(node.__id, node.__url, node.__format, node.__key)
  }

  static importJSON(serializedNode) {
    const node = $createFigmaNode(serializedNode.documentID, serializedNode.url)
    node.setFormat(serializedNode.format)
    return node
  }

  exportJSON() {
    return {
      ...super.exportJSON(),
      documentID: this.__id,
      url: this.__url,
      type: "figma",
      version: 1,
    }
  }

  constructor(id, url, format, key) {
    super(format, key)
    this.__id = id
    this.__url = url
  }

  updateDOM() {
    return false
  }

  getId() {
    return this.__id
  }

  getTextContent() {
    return this?.__url ? this.__url : `https://www.figma.com/file/${this.__id}`
  }

  decorate(_editor, config) {
    const embedBlockTheme = config.theme.embedBlock || {}
    const className = {
      base: embedBlockTheme.base || "",
      focus: embedBlockTheme.focus || "",
    }

    return (
      <FigmaComponent
        className={className}
        format={this.__format}
        nodeKey={this.getKey()}
        documentID={this.__id}
        url={this.__url}
      />
    )
  }
}

export function $createFigmaNode(documentID, url) {
  return new FigmaNode(documentID, url)
}

export function $isFigmaNode(node) {
  return node instanceof FigmaNode
}
